import { Button, Container, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axiosApi from "../../axios/axios-api";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ValidateToken } from "../../helpers/validateToken";
import { startLogout } from "../../store/auth";
import warning_icon from "../../assets/images/warning-icon-red.svg";
import { LogoPetroprix } from "../ui/LogoPetroprix";

const URL_DELETE_VEHICULOS_FLOTA = "flotas/vehiculos";

export function ModalEliminarVehiculos(props) {
  const { show, vehicles } = props;
  const { t } = useTranslation();
  const { token, idClienteFlota } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const eliminarVehiculos = async () => {
    try {
      let data = {
        confirmation: true,
        id_vehicles_fleet: [...vehicles],
      };

      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.delete(
          `${URL_DELETE_VEHICULOS_FLOTA}/${idClienteFlota}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
            data,
          }
        );
        if (response?.data?.code === 200 || response?.data?.code === 206) {
          props.onHide(true);

          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
        } else {
          props.onHide(false);
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
        }
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      console.error(error);
      props.onHide();
    }
  };

  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={() => props.onHide()}
    >
      <Container className="py-5" align="center">
        <Modal.Body>
          <div className="mb-3">
            <span className="p-1 ">
              <img color="" src={warning_icon} alt="" />
            </span>
          </div>

          <h3 className="title-modal">{t("flotas.modal-vehiculos.h1")}</h3>
          <div className="grid gap-2  mt-2">
            <p color="rgba(43, 54, 59, 0.75)">
              {t("flotas.modal-vehiculos.p")}
            </p>
          </div>
          <div className="d-grid gap-2">
            <Button
              variant="outline-primary"
              size="lg"
              onClick={() => {
                props.onHide();
              }}
            >
              {t("flotas.modal-vehiculos.cancelar")}
            </Button>
            <Button
              variant="primary"
              size="lg"
              onClick={() => {
                eliminarVehiculos();
              }}
            >
              {t("flotas.table.eliminar")}
            </Button>
          </div>
        </Modal.Body>
      </Container>
    </Modal>
  );
}
